import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import Logo from '../assets/logo.png';

const Navbar2 = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={`fixed top-0 inset-x-0 z-[100] transition-all duration-350 flex flex-col ${
        scrolled 
          ? 'bg-white/95 backdrop-blur-md border-b border-[#F1F3F1] shadow-sm' 
          : 'bg-transparent'
      }`}>
        {/* Top Contact Bar */}
        <div className={`bg-[#FAFBF9] border-b border-[#F1F3F1] md:bg-transparent md:border-transparent text-[11px] font-semibold uppercase tracking-wider text-[#5A635A] py-2 px-6 sm:px-10 lg:px-16 w-full ${scrolled ? 'hidden' : 'block'}`}>
          <div className="max-w-7xl mx-auto flex flex-row justify-center sm:justify-start items-center gap-6">
            <div className="flex items-center gap-2">
              <FaPhoneAlt size={10} className="text-[#1C2E1E]" />
              <span>+91 9164752256</span>
            </div>
            <div className="flex items-center gap-2">
              <FaEnvelope size={10} className="text-[#1C2E1E]" />
              <span>contact@cyborgsapient.com</span>
            </div>
          </div>
        </div>

        {/* Navbar Row */}
        <div className={`w-full px-6 sm:px-10 lg:px-16 flex flex-row justify-between items-center transition-all duration-350 ${
          scrolled ? 'py-3.5 sm:py-4' : 'py-5 sm:py-6'
        }`}>
        {/* Logo */}
        <Link to="/" className="flex flex-row items-center gap-3">
          <img src={Logo} alt="Cyborg Sapient" className="h-8 sm:h-10 w-auto object-contain" />
        </Link>

        {/* Center Nav Links */}
        <nav className="hidden md:flex flex-row items-center text-[20px] lg:text-[22px] text-black font-normal">
          <Link to="/" className="hover:opacity-60 transition-opacity">home</Link>
          <span className="opacity-40">,&nbsp;</span>
          <Link to="/services" className="hover:opacity-60 transition-opacity">services</Link>
          <span className="opacity-40">,&nbsp;</span>
          <Link to="/influencer" className="hover:opacity-60 transition-opacity">influencer</Link>
          <span className="opacity-40">,&nbsp;</span>
          <Link to="/upskill" className="hover:opacity-60 transition-opacity">upskill</Link>
          <span className="opacity-40">,&nbsp;</span>
          <Link to="/blog" className="hover:opacity-60 transition-opacity">blog</Link>
        </nav>

        {/* Right CTA */}
        <Link 
          to="/contact" 
          className="hidden md:inline-block text-[20px] lg:text-[22px] text-black underline underline-offset-2 hover:opacity-60 transition-opacity"
        >
          Get in touch
        </Link>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden flex flex-col justify-between w-6 h-[16px] z-[101] relative focus:outline-none"
          aria-label="Toggle Mobile Menu"
        >
          <span className={`w-6 h-[2px] bg-black transition-all duration-300 transform ${isMobileMenuOpen ? 'rotate-45 translate-y-[7px]' : ''}`} />
          <span className={`w-6 h-[2px] bg-black transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : 'opacity-100'}`} />
          <span className={`w-6 h-[2px] bg-black transition-all duration-300 transform ${isMobileMenuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} />
        </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div 
        className={`md:hidden fixed inset-0 z-[99] bg-white/95 backdrop-blur-sm transition-opacity duration-300 flex flex-col items-center justify-center gap-8 ${
          isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <Link 
          to="/" 
          onClick={() => setIsMobileMenuOpen(false)} 
          className="text-3xl text-black hover:opacity-60 transition-opacity font-medium"
        >
          home
        </Link>
        <Link 
          to="/services" 
          onClick={() => setIsMobileMenuOpen(false)} 
          className="text-3xl text-black hover:opacity-60 transition-opacity font-medium"
        >
          services
        </Link>
        <Link 
          to="/influencer" 
          onClick={() => setIsMobileMenuOpen(false)} 
          className="text-3xl text-black hover:opacity-60 transition-opacity font-medium"
        >
          influencer
        </Link>
        <Link 
          to="/upskill" 
          onClick={() => setIsMobileMenuOpen(false)} 
          className="text-3xl text-black hover:opacity-60 transition-opacity font-medium"
        >
          upskill
        </Link>
        <Link 
          to="/blog" 
          onClick={() => setIsMobileMenuOpen(false)} 
          className="text-3xl text-black hover:opacity-60 transition-opacity font-medium"
        >
          blog
        </Link>
        <Link 
          to="/contact" 
          onClick={() => setIsMobileMenuOpen(false)} 
          className="text-3xl text-black underline underline-offset-4 hover:opacity-60 transition-opacity font-medium mt-4"
        >
          Get in touch
        </Link>
      </div>
    </>
  );
};

export default Navbar2;
